import React from 'react';
import styled from 'styled-components';

import ContentButton from './ContentButton';

type Props = {
  hasBeenGenerated?: boolean;
  renderCreateNew?: () => React.ReactNode;
  onGenerate?: () => void;
  onRegenerate?: () => void;
  onShare?: () => void;
  renderShare?: () => React.ReactNode;
  onCopy?: () => void;
  copied?: boolean;
  onSave?: () => void;
  saveDisabled?: boolean;
  saveButtonLabel?: string;
  alwaysShowGenerate?: boolean;
  generateVariant?: 'outlined' | 'primary';
  generateButtonLabel?: string;
  renderCenter?: () => React.ReactNode;
  renderLeft?: () => React.ReactNode;
  renderBeforeActions?: () => React.ReactNode;
  'data-testid'?: string;
  generateTestId?: string;
};

const ContentActions = (props: Props) => {
  const {
    hasBeenGenerated,
    renderCreateNew,
    onGenerate,
    onRegenerate,
    onShare,
    renderShare,
    onCopy,
    copied,
    onSave,
    saveDisabled,
    saveButtonLabel = 'Save',
    alwaysShowGenerate,
    generateVariant,
    generateButtonLabel,
    renderCenter,
    renderLeft,
    renderBeforeActions,
    generateTestId,
  } = props;
  return (
    <Container data-testid={props['data-testid'] ?? 'content-actions-bar'}>
      {renderLeft && renderLeft()}
      {hasBeenGenerated &&
        (renderCreateNew
          ? renderCreateNew()
          : onGenerate && (
              <ContentButton
                onClick={onGenerate}
                icon="create"
                buttonLabel="Create New"
              />
            ))}
      {renderCenter && renderCenter()}
      <RightActions>
        {renderBeforeActions && renderBeforeActions()}
        {(!hasBeenGenerated || alwaysShowGenerate) && onGenerate && (
          <ContentButton
            onClick={onGenerate}
            icon={hasBeenGenerated ? 'create' : 'generate'}
            buttonLabel={hasBeenGenerated ? 'Create New' : generateButtonLabel}
            variant={
              generateVariant || (hasBeenGenerated ? 'outlined' : 'primary')
            }
            data-testid={generateTestId}
          />
        )}
        {hasBeenGenerated && onRegenerate && (
          <ContentButton
            onClick={onRegenerate}
            variant="outlined"
            icon="regenerate"
            buttonLabel="Regenerate"
          />
        )}
        {renderShare
          ? renderShare()
          : onShare && (
              <ContentButton
                onClick={onShare}
                variant="outlined"
                icon="share"
                buttonLabel="Share"
              />
            )}
        {onCopy && (
          <ContentButton
            onClick={onCopy}
            variant={copied ? 'primary' : 'outlined'}
            icon="copy"
            buttonLabel={copied ? 'Copied!' : 'Copy'}
          />
        )}
        {onSave && (
          <ContentButton
            onClick={onSave}
            disabled={saveDisabled}
            variant="primary"
            icon="save"
            buttonLabel={saveButtonLabel}
          />
        )}
      </RightActions>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-end;
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export default ContentActions;
